// Core viewer
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LOGOUT } from "../store/actions";
import LoginService from "../views/login/login-service";
import { useEffect, useState } from "react";

// Plugins
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// Import styles
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const PdfModal = ({ fileUrl }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginServiceInstance = new LoginService();
  const [hasError, setHasError] = useState(false);

  // Create new plugin instance
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const handleLogout = async () => {
    try {
      await loginServiceInstance.logout();
      dispatch({ type: LOGOUT });
      localStorage.removeItem("star_prev_url");
      navigate("/login");
    } catch (error) {
      // If logout fails, still clear local storage and navigate
      dispatch({ type: LOGOUT });
      localStorage.removeItem("star_prev_url");
      navigate("/login");
    }
  };

  useEffect(() => {
    // Check if the file URL is accessible
    if (fileUrl && !fileUrl.startsWith('blob:')) {
      fetch(fileUrl, { method: 'HEAD' })
        .then(response => {
          if (!response.ok) {
            setHasError(true);
            handleLogout();
          }
        })
        .catch(() => {
          setHasError(true);
          handleLogout();
        });
    }
  }, [fileUrl]);

  if (hasError) {
    return null; // Don't render anything if there's an error
  }

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
      <Viewer
        fileUrl={fileUrl}
        plugins={[
          // Register plugins
          defaultLayoutPluginInstance,
        ]}
      />
    </Worker>
  );
};

export default PdfModal;
